import { QualityList } from '@/api/reportApi'
import { UserScopePermissionRes } from '@/api/user'
import { materialTypeEnum, qualityTypeEnum } from '@/global/enum/product'
import { getMissingQualityTypes } from './qualityRequirement'

// 计算所选平台缺失的必传资质图片类型名称
export function getMissingQualityTypeLabels(
  platformCodes: string[],
  qualityDataList: QualityList[] = [],
): string[] {
  return getMissingQualityTypes(platformCodes, qualityDataList).map(
    (type) => qualityTypeEnum.getLabelByValue(type) || type,
  )
}

export function filterPermissionTypeFn(
  item: any,
  options: {
    userInfo: UserScopePermissionRes | null
  },
) {
  const { userInfo } = options
  if (!userInfo) {
    return false
  }
  if (
    materialTypeEnum.isLabelsMatchValue(['电商供应商物料'], item.value) &&
    userInfo?.permissionNameList?.includes('电商供应商')
  ) {
    return true
  }
  if (
    materialTypeEnum.isLabelsMatchValue(['供应商物料'], item.value) &&
    userInfo?.permissionNameList?.includes('自营供应商')
  ) {
    return true
  }
  return false
}
import { QualityList } from '@/api/reportApi'
import { UserScopePermissionRes } from '@/api/user'
import { materialTypeEnum, qualityTypeEnum } from '@/global/enum/product'
import { getMissingQualityTypes } from './qualityRequirement'

// 计算所选平台缺失的必传资质图片类型名称
export function getMissingQualityTypeLabels(
  platformCodes: string[],
  qualityDataList: QualityList[] = [],
): string[] {
  return getMissingQualityTypes(platformCodes, qualityDataList).map(
    (type) => qualityTypeEnum.getLabelByValue(type) || type,
  )
}

export function filterPermissionTypeFn(
  item: any,
  options: {
    userInfo: UserScopePermissionRes | null
  },
) {
  const { userInfo } = options
  if (!userInfo) {
    return false
  }
  if (
    materialTypeEnum.isLabelsMatchValue(['电商供应商物料'], item.value) &&
    userInfo?.permissionNameList?.includes('电商供应商')
  ) {
    return true
  }
  if (
    materialTypeEnum.isLabelsMatchValue(['供应商物料'], item.value) &&
    userInfo?.permissionNameList?.includes('自营供应商')
  ) {
    return true
  }
  return false
}
